{
  "cc-performance-enablement.confluence-performance-diagnstic-survey.description.no-translate": [
    {
      "type": 0,
      "value": "Atlassians: got one minute to help make Confluence faster? Five quick questions about your current experience using Confluence on Hello."
    }
  ],
  "cc-performance-enablement.confluence-performance-diagnstic-survey.title.no-translate": [
    {
      "type": 0,
      "value": "Confluence performance survey"
    }
  ]
}